import Rating, { RatingProps } from '@mui/material/Rating'
import { InputBaseComponentProps } from '@mui/material/InputBase'
import React from 'react'
import Star from '@mui/icons-material/Star'
import StarBorder from '@mui/icons-material/StarBorder'
import Grid from '@mui/material/Grid2'
import { InputField } from '../InputField'
import { ILevel } from 'types/levelItemInterfaces'

type WrappedRatingProps = InputBaseComponentProps & RatingProps

const WrappedRating = React.forwardRef<HTMLInputElement, WrappedRatingProps>((props, ref) => {
  const { className, value, ...rest } = props
  return (
    <Grid className={className}>
      <Rating value={Number(value)} ref={ref} {...rest} />
    </Grid>
  )
})

const NewLevePicker = <T extends ILevel>({
  value,
  onChange,
  disabled = false,
  label = 'Level',
  required,
  precision,
  max,
  icon,
  emptyIcon,
  ...rest
}: {
  value: T | null
  onChange: (newValue: string) => void
  disabled?: boolean
  label?: string
  required?: boolean
  precision?: number
  max?: number
  icon?: React.ReactElement
  emptyIcon?: React.ReactElement
}) => {
  return (
    <InputField
      value={value}
      label={label}
      onChange={e => {
        onChange(e.target.value)
      }}
      slotProps={{
        inputLabel: { shrink: true },
        input: {
          inputComponent: props => <WrappedRating {...props} />,
          inputProps: {
            max: max ? max : 5,
            icon: icon ? icon : <Star fontSize="inherit" />,
            emptyIcon: emptyIcon ? emptyIcon : <StarBorder fontSize="inherit" />,
            precision: precision ? precision : 1,
          },
        },
      }}
      disabled={disabled}
      required={required}
      insetLabel
      {...rest}
    />
  )
}

export default NewLevePicker
